import React from 'react';

import styles from '../styles.module.scss';
import antiRaidStyles from './AntiRaid.module.scss';
import {AntiRaid, ArrowLong} from '../../../assets';

export const AntiRaidCard = () => {
  return (
    <div className={antiRaidStyles.card}>
      <div className={styles.top}>
        <div className={styles.label}>
          <div className={styles.labelInner}>SECURITY</div>
        </div>
        <div className={styles.buttonForward}>
          <ArrowLong />
        </div>
      </div>

      <h4 className={styles.title}>Anti-Raid</h4>
      <p className={styles.subTitle}>
        The bot prevents bot raids by employing a flexible, ML-driven algorithm that works to
        prevent bot raids on your server.
      </p>
      <div className={antiRaidStyles.image}>
        <AntiRaid />
      </div>
    </div>
  );
};
